import { Badge } from "@/components/ui/badge";
import { CheckCircle, Clock, LoaderCircle } from "lucide-react";
import { AssessmentPortalStatus } from "../../course-service";

interface AssessmentBadgeProps {
  isCreating: boolean;
  status: AssessmentPortalStatus;
}

export const AssessmentBadge = ({ isCreating, status }: AssessmentBadgeProps) => {
  if (isCreating) {
    return (
      <Badge variant="secondary">
        Creating...
        <LoaderCircle className="w-4 h-4 ml-1 animate-spin" />
      </Badge>
    );
  }
  
  switch (status) {
    case "concluded":
      return (
        <Badge variant="secondary" >
          Completed
          <CheckCircle className="w-4 h-4 ml-1" />
        </Badge>
      );
    case "live_in_portal":
      return (
        <Badge variant="outline" className=" border-blue-300 text-blue-600">
          Live in portal
        </Badge>
      );
    case "scheduled":
      return (
        <Badge variant="outline">
          Scheduled
          <Clock className="w-4 h-4 ml-1" />
        </Badge>
      );
    case "review":
      return (
        <Badge variant="outline" className="border-brand text-brand">
          In review
        </Badge>
      );
    case "pending":
    default:
      return (
        <Badge variant="outline">
          Oustanding
        </Badge>
      );
  }
};
